import { Stack } from "@mui/material"
import { STEPS } from "../consts"
import Finish from "./Finish"
import Home from "./Home"
import Question from "./Question"
import Riddle from "./Riddle"
import ScannerPremissionDialog from "../components/QrCodeScanner/ScannerPremissionDialog"
import GoToParkEntry from "./GoToParkEntry"

const Steps = ({ step, finishedRiddle, riddle, handleNext, sendAddStat }) => {

    // Check for URL params
    const hasUrlParams = typeof window !== "undefined" && window.location.pathname && window.location.pathname.length > 1;

    return (
        <Stack>
            {hasUrlParams
                ? <GoToParkEntry />
                : <>
                    {step === STEPS.HOME && (
                        <Home handleNext={handleNext} />
                    )}

                    {step === STEPS.RIDDLE && (
                        <Riddle step={step} finishedRiddle={finishedRiddle} riddle={riddle} />
                    )}

                    {step === STEPS.QUESTION && (
                        <Question step={step} handleNext={handleNext} riddle={riddle} sendAddStat={sendAddStat} />
                    )}

                    {step === STEPS.FINISH && (
                        <Finish sendAddStat={sendAddStat} />
                    )}

                    {step !== STEPS.HOME &&
                        <ScannerPremissionDialog />
                    }
                </>
            }
        </Stack>
    )
}
export default Steps